import { secondsToHours } from '@/lib/utils/secondsToHours';

export const formatHours = (hours: number): string => {
  return Number.isInteger(hours) ? `${hours.toFixed(0)}h` : `${hours.toFixed(1)}h`;
};

export const formatSecondsToHours = (seconds: number): string => {
  return formatHours(secondsToHours(seconds));
};
